/**
 * Controller: removeModal
 */
angular.module('acme.view.application.donations.amount.removeModal.controllers', [])
.controller('DonationsAmountRemoveModalController', [ '$scope', '$uibModalInstance', 'currentInventory', function($scope, $uibModalInstance, currentInventory) {

  $scope.errors = [];

  $scope.model = {
    name: currentInventory.name
  };

  $scope.init = function() {

  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.done = function() {
    $scope.success();
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $uibModalInstance.close(true);
  };

  $scope.init();

}]);
